module.exports = __webpack_public_path__ + "static/app-store-badge-ms-0d65c7b04fdd0560fe2dd8b4db2e3388.png";